/**
 * Query options for the pending-review queues.
 *
 * Work in these queues arrives from other people: a designer submits while the
 * console sits open in another tab. The console's default (60s fresh, no
 * refetch on focus; see `ADMIN_QUERY_DEFAULTS`) would show a reviewer the queue
 * as it was when they last looked, so these refetch on every mount and every
 * return to the window.
 */
export const PENDING_QUEUE_QUERY_OPTIONS = {
	staleTime: 0,
	refetchOnWindowFocus: true,
} as const;
